// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FfuD","buttons":"styles_buttons__VwPp4"};